export default __webpack_public_path__ + "static/media/principal.fe7f2015.jpg";